import {
  ChangeDetectorRef,
  Directive,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  OnInit,
  Output,
  Renderer2,
} from '@angular/core';

import { Ng2ImgMaxService } from 'ng2-img-max';
import { RxUploadService } from '../rx-upload.service';

@Directive({
  selector: '[rxUpload]',
})
export class RxUploadDirective implements OnInit {
  public input: HTMLInputElement;

  @Input() multiple: any = null;

  @Input() disabled: boolean;

  @Input() imageSize: any | { width: number; height: number } = null;

  // @Input() keepWidth = 1536;
  @Input() keepWidth: any = null;

  @Input() accept = 'image/*,video/*';

  @Output() checkedChange = new EventEmitter<any>();

  @Output() uploadedFiles = new EventEmitter<any>();

  @HostBinding('style.color') private color = 'white';

  @HostListener('click', ['$event']) public onRxUpload(evt) {
    evt.preventDefault();
    evt.stopPropagation();

    if (!this.disabled) {
      this.input.click();
    }
  }

  constructor(
    private render: Renderer2,
    private service: RxUploadService,
    private _cd: ChangeDetectorRef,
    private ng2ImgMaxService: Ng2ImgMaxService,
  ) {}

  ngOnInit() {
    this.input = this.render.createElement('input');
    this.input.type = 'file';
    this.input.accept = this.accept;
    this.input.onchange = (e) => {
      this.selectedFile(e);
    };
    this.input.multiple = <any>this.multiple;

    if (this.imageSize && this.imageSize.width) {
      this.keepWidth = this.imageSize.width;
    }
  }

  selectedFile(event) {
    this.checkedChange.emit(this.service.transform(event.target.files));
    let temp = null;

    if (event.target.files.length) {
      temp = event.target.files[0];
    }

    if (this.keepWidth && temp) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const image = new Image();
        image.onload = () => {
          const aspectRatio = image.width / image.height;
          image.width > this.keepWidth
            ? this.reSizeAndEmit(temp, this.keepWidth, this.keepWidth / aspectRatio)
            : this.uploadedFiles.emit(temp);
        };
        image.src = e.target.result;
        this._cd.detectChanges();
      };
      reader.readAsDataURL(temp);
    } else if (this.imageSize && temp) {
      const temp = event.target.files[0];
      this.reSizeAndEmit(temp, this.imageSize.width, this.imageSize.height);
    } else {
      this.uploadedFiles.emit(event.target.files);
    }
  }

  private reSizeAndEmit(file: File, width: number, height: number) {
    this.ng2ImgMaxService.resize([file], width, height).subscribe((result) => {
      this.uploadedFiles.emit(new File([result], result.name, result));
    });
  }
}
